(function(){
	//take all whitespace out of string
    angular.module('tmx-app').filter('nospace', function () {
        return removeSpace;
    })

    function removeSpace(input){
    	input.replace(" ","");
    }

})();